<template>
    <div class="order">
        <div class="luck-btn flex_between"> 
            <div class="flex" style="align-items: center;">
                <p>资金计划表-</p>
                <p style="color:#409EFF;">截止{{endDate}}</p>
            </div>
            <div><span>单位：辆/元</span></div>
            
        </div>
        <div id="luckysheet" v-loading="loading" ref="scrollview" @mousewheel="scrollChange"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
        
        </div>
    </div>
</template>
<script>
import { firstHeader,border } from '@/assets/js/fund'
// import { getIndexArrOne,getRC,getIndexArrMonth} from '@/util/getTableData';
export default {
    props:{
        data:{
            type:Object,
            default:{}
        },
        sdate:{
            type:String,
            default:''
        },
        edate:{
            type:String,
            default:''
        },
       
    },
    data(){
        return{
            edited:[],
            canEdit:[],
            tableLength:0,
            tableData:this.data,
            date:[],
            endDate:'',
            mydata:[],
            loading:false,
            options:{}
        }
    },
    mounted(){
        let _this = this
        this.options =  {
                container: 'luckysheet', //容器id名
                title: '资金计划表', // 表 头名
                lang: 'zh', // 中文
                showtoolbar: false, // 是否显示工具栏
                showinfobar: false, // 是否显示顶部信息栏
                showsheetbar:false,
                // showstatisticBar:false,
                enableAddRow:false,
                sheetFormulaBar:false,
                enableAddRow:false,
                enableAddBackTop:false,
                accuracy:0,
                cellRightClickConfig:{
                    
                    copy: false, // 复制
                    copyAs: false, // 复制为
                    paste: false, // 粘贴
                    insertRow: false, // 插入行
                    insertColumn: false, // 插入列
                    deleteRow: false, // 删除选中行
                    deleteColumn: false, // 删除选中列
                    deleteCell: false, // 删除单元格
                    hideRow: true, // 隐藏选中行和显示选中行
                    hideColumn: true, // 隐藏选中列和显示选中列
                    rowHeight: false, // 行高
                    columnWidth: false, // 列宽
                    clear: false, // 清除内容
                    matrix: false, // 矩阵操作选区
                    sort: false, // 排序选区
                    filter: false, // 筛选选区
                    chart: false, // 图表生成
                    image: false, // 插入图片
                    link: false, // 插入链接
                    data: false, // 数据验证
	                cellFormat: false // 设置单元格格式
                },
                hook: {
                    cellUpdated: function (r, c, oldValue, newValue, isRefresh) {
                        if(isRefresh){
                            if(_this.edited.length>0){
                                const has = _this.edited.filter(item=>item.r==r&&item.c==c)
                                if(has.length>0){
                                    _this.edited.forEach(item=>{
                                        if(item.r==r&&item.c==c){
                                            item.v = newValue.v
                                        }
                                    })
                                }else{
                                    _this.edited.push({r:r,c:c,v:newValue.v})
                                }
                            }else{
                                _this.edited.push({r:r,c:c,v:newValue.v})
                            }
                            _this.edited.forEach(item=>{
                                
                                item.name = window.luckysheet.getCellValue(item.r,3)
                                item.date = window.luckysheet.getCellValue(0,item.c)
                            })
                            _this.$emit('getEditData',_this.edited)
                            window.luckysheet.exitEditMode()
                           
                        }
                    }
                }
            }
        let arr = this.edate.split("-")
        this.endDate = arr[0]+'年'+arr[1]+'月'
        this.tableLength = 9+(this.data.capitalPlanOtherMethodList.length*5)
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        this.getExcelDate()
        const scrollview = this.$refs['scrollview']
        scrollview.addEventListener('scroll', this.scrollChange, true)
        // this.handleTest()
       
    },
    methods:{
        scrollChange () {
            window.luckysheet.exitEditMode()
        },
        // 计算年月
        getExcelDate(){
            let sy= Number(this.sdate.split("-")[0]);
            let ey= Number(this.edate.split("-")[0]);
            let sm = Number(this.sdate.split("-")[1]);
            let em = Number(this.edate.split("-")[1]);

            let y ;
            let date = []
            if(sy==ey){//同一年
                if(em>sm){
                    for(let i=sm;i<=em;i++){
                        date.push(`${sy}年${i}月`)
                    }
                }else if(em==sm){
                    date.push(`${ey}年${em}月`)
                }else{
                    this.$DonMessage.warning("结束日期必须在开始日期之后")
                }
            }else if(ey>sy){//不同年
                y = ey-sy
                if(y==1){// 没有间隔的一整年
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }
                if(y>1){//中间有完整一整年
                    let fwy = sy+1
                    let lwy = ey-1
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let year=fwy;year<=lwy;year++){
                        for(let month=1;month<=12;month++){
                            date.push(`${year}年${month}月`)
                        } 
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }

            }else{
                this.$DonMessage.warning("结束日期必须在开始日期之后")
            }
            this.date = date
            this.handleTest()
        },
        demo(){
            if(this.mydata[0].celldata.length>0){
                window.luckysheet.destroy();
                this.options.data = this.mydata;
                window.luckysheet.create(this.options);
                this.$store.state.excelLoading = false
                 window.luckysheet.setDataVerification(//期初数编辑规则
                    {
                        type: 'number_integer',
                        type2: "bw",
                        value1: 0,
                        value2: 99999,
                        prohibitInput: true
                    },
                    {
                        range: `E2:E${this.tableLength}`
                    }
                )
                this.canEdit.map(item=>{
                    window.luckysheet.setDataVerification(
                        {
                            type: 'number',
                            type2: "bw",
                            value1: '0.00',
                            value2: '1000000.00',
                            prohibitInput: true
                        },
                        {
                            range: `G${item}:GX${item}`
                        }
                    )
                })
                let bgArr = []
                bgArr.push(`A6:EX7`)
                this.canEdit.map(item=>{
                    bgArr.push(`A${item}:EX${item}`)
                })
             
                if(bgArr.length>0){
                    window.luckysheet.setRangeFormat("bg", '#E3F2D9', {range:[...bgArr]})
                }
                window.luckysheet.setRangeShow({ row:[0], column:[0] }, {
                    show: false, // 选中状态不要高亮
                })
                // window.luckysheet.setRangeFormat("bg", '#eee', {range:["A2:X2","A10:X10",'A15:X15','A25:X25','A20:X20',]})
            }
        },
        handleTest(){
            // 计算每个车型可编辑项的规律是哪一行
            this.canEdit = []
            this.data.capitalPlanOtherMethodList.map((item,i)=>{
                this.canEdit.push(13+5*i)
            })
            this.mydata = [
                {   
                    name: "这个是sheet1",
                    celldata: [],
                    frozen:{
                       type: 'rangeBoth',
                       range: {row_focus: 0, column_focus: 3}
                    },
                   
                    config: {
                        authority:{// 当前工作表的权限配置
                            sheet: 1, // sheet表下标。
                            hintText: "这部分不可以进行修改", // 弹

                            allowRangeList: [
                                { sqref: `$E$2:$E$${this.tableLength}`},//期初数
                            	{ sqref: '$G$7:$GX$7' },//设置A2~D6为可编辑区域，其它区域不可编辑
                            ],
                        },
                        borderInfo: [],
                    },
                },
            ];
            this.canEdit.map(item=>{
                this.mydata[0].config.authority.allowRangeList.push(
                    { sqref: `$G$${item}:$GX$${item}` }
                )
            })
            // 年月数据
            if(this.date.length>0){
                this.date.map((item,index)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:0,
                            c:index+6,
                            v:{
                                bg:"#195c96",
                                bl: 1, 
                                v:item,
                                ht:0,
                                fc:'#fff'
                            },

                        }
                    )
                })

            }
            let borderArr = []//边框数据
            let types = ['1','','','','','','','',]
            let fk = ['自有资金','','','','','','','',]
            let indexOne = ['','1','1.1','1.2','2','3','4','5']
            let saleHeader = ['','当月标准应支付','当月标准应支付-货款','当月标准应支付-费用','当月实际应支付','当月实付-货款','当月实付-费用','自有资金余额',]
            this.data.capitalPlanOtherMethodList.map((item,i)=>{
                const arr1 = [`${i+2}`,'','','','']
                const arr2 = [item.paymentMethod,'','','','']
                const arr3 = [``,'1','2','3','4',]
                const arr4 = ['','当月标准应支付','当月实际应支付','当月实付',`${item.paymentMethod}余额`]
                types.push(...arr1)
                fk.push(...arr2)
                indexOne.push(...arr3)
                saleHeader.push(...arr4)
                borderArr.push(
                    {
                    "rangeType": "range",
                    "borderType": "border-bottom",
                    "style": "8",
                    "color": "#77b8f9",
                    "range": [{
                        "row": [0, 8+(i*5)],
                        "column": [0, firstHeader.length+this.date.length-1]
                    }]
                })
            })
            this.mydata[0].config.borderInfo = [...borderArr]
            
            types.map((item,index)=>{
                let bg = "#fff"
                if(item!==''){
                    bg = "#eee"
                }
                this.mydata[0].celldata.push(
                    {
                        r:index+1,
                        c:0,
                        v:{
                            v:item,
                            ht:0,
                            bl:1,
                            bg:bg
                        },
                        
                    }
                )
            })                     
            let bge = [1] 
            this.data.capitalPlanOtherMethodList.map((data,i)=>{
                bge.push(9 +5*i)
            })
            let tableWidth = firstHeader.length+this.date.length-1
            for(let j=1;j<=tableWidth;j++){
                bge.map(data=>{
                this.mydata[0].celldata.push(
                    {
                        r:data,
                        c:j,
                        v:{
                            bg:'#eee'
                        },
                        
                    }
                )
            })
            }
            fk.map((item,index)=>{
                let bg = '#fff'
                if(item!==''){
                    bg = '#eee'
                }
                this.mydata[0].celldata.push(
                    {
                        r:index+1,
                        c:1,
                        v:{
                           
                            bl: 1, 
                            v:item,
                            ht:0,
                            bg:bg
                        },
                        
                    }
                )
            })
            // 表头数据项
            firstHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:0,
                        c:index,
                        v:{
                            bg:"#195c96",
                            bl: 1, 
                            v:item,
                            ht:0,
                            fc:'#fff'
                        },
                        
                    }
                )
            })
            
            // 添加序号数据项
            indexOne.map((item,index)=>{
                
                if(item.indexOf('.')==-1){
                        
                        this.mydata[0].celldata.push(
                            {
                                r:index+1,
                                c:2,
                                v:item,
                                v:{
                                    v:item,
                                    ht:0,
                                    
                                },


                            }
                        )
                        
                        
                    }else{
                        this.mydata[0].celldata.push(
                            {
                                r:index+1,
                                c:2, 
                                v:{ 
                                    v:item,
                                    ht:2
                                },
                            }
                        )
                    }
            })
            
            // 添加销量项目名
            saleHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:index+1,
                        c:3,
                        v:{
                            v:item,
                            ht:0
                        },
                    }
                )
            })
            this.fillPosition()
            
           
            
        },
        fillPosition(){
            // 当月实际   余额
            // currentMonthActualPayableOpeningBalance  capitalBalanceOpeningBalance
            this.tableData.capitalPlanOtherMethodList.map((item,j)=>{//其他方式
                    item.currentMonthStandardPayable.forEach((b,i)=>{//当月标准应支付
                        this.mydata[0].celldata.push(
                            {//11/16
                                r:10+j*5,
                                c:i+6,
                                v:{ 
                                    v:b,
                                    ht:0
                                },
                            }
                        )
                    })
                    item.currentMonthActualPayable.forEach((b,i)=>{//当月实际应支付
                        this.mydata[0].celldata.push(
                            {//11/16
                                r:11+j*5,
                                c:i+6,
                                v:{ 
                                    v:b,
                                    ht:0
                                },
                            }
                        )
                    })
                    item.currentMonthActualPaid.forEach((b,i)=>{//当月实付
                        this.mydata[0].celldata.push(
                            {//11/16
                                r:12+j*5,
                                c:i+6,
                                v:{ 
                                    v:b,
                                    ht:0
                                },
                            }
                        )
                    })
                    item.capitalBalance.forEach((b,i)=>{//资金余额
                        this.mydata[0].celldata.push(
                            {//11/16
                                r:13+j*5,
                                c:i+6,
                                v:{ 
                                    v:b,
                                    ht:0
                                },
                            }
                        )
                    })
                    
                    this.mydata[0].celldata.push(
                       
                        {
                            r:11+j*5,
                            c:4,
                            v:{ 
                                v:item.currentMonthActualPayableOpeningBalance,// 实际应支付期初数
                                ht:0
                            },
                        },
                        {
                            r:13+j*5,
                            c:4,
                            v:{ 
                                v:item.capitalBalanceOpeningBalance,// 余额期初数
                                ht:0
                            },
                        },
                         // 期初数
                        {
                            r:10+j*5,
                            c:5,
                            v:{ 
                                v:item.currentMonthStandardPayableSum,
                                ht:0
                            },
                        },
                        {
                            r:11+j*5,
                            c:5,
                            v:{ 
                                v:item.currentMonthActualPayableSum,
                                ht:0
                            },
                        },
                        {
                            r:12+j*5,
                            c:5,
                            v:{ 
                                v:item.currentMonthActualPaidSum,
                                ht:0
                            },
                        },
                        {
                            r:13+j*5,
                            c:5,
                            v:{ 
                                v:item.capitalBalanceSum,
                                ht:0
                            },
                        },
                    )
            })
            let obj = this.tableData.capitalPlanOwnCapital
            this.mydata[0].celldata.push(// 合计
                    {
                        r:5,
                        c:4,
                        v:{ 
                            v:obj.currentMonthActualPayableOpeningBalance,
                            ht:0
                        },
                    },
                    {
                        r:8,
                        c:4,
                        v:{ 
                            v:obj.ownCapitalBalanceOpeningBalance,
                            ht:0
                        },
                    },
                    {
                        r:2,
                        c:5,
                        v:{ 
                            v:obj.currentMonthStandardPayableSum,
                            ht:0
                        },
                    },
                    {
                        r:3,
                        c:5,
                        v:{ 
                            v:obj.currentMonthStandardPayableGoodsSum,
                            ht:0
                        },
                    },
                    {
                        r:5,
                        c:5,
                        v:{ 
                            v:obj.currentMonthActualPayableSum,
                            ht:0
                        },
                    },
                    {
                        r:4,
                        c:5,
                        v:{ 
                            v:obj.currentMonthStandardPayableExpensesSum,
                            ht:0
                        },
                    },
                    {
                        r:6,
                        c:5,
                        v:{ 
                            v:obj.currentMonthActualPaidGoodsSum,
                            ht:0
                        },
                    },
                    {
                        r:7,
                        c:5,
                        v:{ 
                            v:obj.currentMonthActualPaidExpensesSum,
                            ht:0
                        },
                    },
                    {
                        r:8,
                        c:5,
                        v:{ 
                            v:obj.ownCapitalBalanceSum,
                            ht:0
                        },
                    },
                   
            )
            obj.currentMonthStandardPayable.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:2,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj.currentMonthStandardPayableGoods.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:3,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj.currentMonthActualPayable.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:5,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj.currentMonthStandardPayableExpenses.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:4,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj.currentMonthActualPaidGoods.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:6,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj.currentMonthActualPaidExpenses.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:7,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj.ownCapitalBalance.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:8,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
                
            
            this.demo()
        }
    },
    beforeDestroy(){
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        const scrollview = this.$refs['scrollview']
        scrollview.addEventListener('scroll', this.scrollChange, true)
    },
}
</script>
<style lang="scss" scoped>
.order{
    min-height:calc(100vh - 100px);
    overflow: hidden;
    // background: pink;
    position: relative;
    #luckysheet{
        margin:0px;
        padding:0px;
        position:absolute;
        width:98%;
        box-sizing: border-box;
        left: 0px;
        top: 82px;
        bottom:0px;
        height: 88%;
    }
    .luck-btn{
        width: 100%;
        background: #fff;
        padding: 6px;
        box-sizing: border-box;
        margin-top: 50px;
        // align-items: center;
        p{
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-right: 10px;
        }
        span{
            font-size: 12px;
            
        }
    }

}
</style>